import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { IconButton, Stack } from "@mui/material";
import { memo } from 'react';

export type PaginationControlPropType = {
  hasNext: boolean;
  hasPrevious: boolean;
  onNext: () => void;
  onPrevious: () => void;
  current: number;
  last: number | null;
};

export default memo(function PaginationControl({
  hasNext,
  hasPrevious,
  onNext,
  onPrevious,
  current,
  last,
}: PaginationControlPropType) {
  return (
    <Stack direction="row" gap={2} alignItems={"center"}>
        <IconButton disabled={!hasPrevious} onClick={onPrevious}><ChevronLeft /></IconButton>
        <span>{current} / {last}</span>
        <IconButton disabled={!hasNext} onClick={onNext}><ChevronRight /></IconButton>
    </Stack>
  );
});